import React from 'react';
import { Modal } from 'react-bootstrap';
import { TextInput, LongTextInput, NumberInput, CheckBox, DropdownSelector } from 'hyperdb-utils';
import UnitsFieldset from './UnitsFieldset';
import ModalCreateGroup from './ModalCreateGroup';
import ModalCreateOwner from './ModalCreateOwner';

const ManagementTab = (props) => {
  const units = (props.objectData.units || []).slice();
  units.sort((a, b) => a.number - b.number);
  return (
    <div style={ {display: props.show ? 'block' : 'none'} }>
      <fieldset>
        <CheckBox
          label="Active"
          name="active"
          checked={ props.objectData.active }
          onChange={ props.onClickCheckbox.bind(null, 'active') }
        />
        <CheckBox
          label="Daily rental"
          name="daily_rental"
          checked={ props.objectData.daily_rental }
          onChange={ props.onClickCheckbox.bind(null, 'daily_rental') }
        />
        <CheckBox
          label="Monthly rental"
          name="monthly_rental"
          checked={ props.objectData.monthly_rental }
          onChange={ props.onClickCheckbox.bind(null, 'monthly_rental') }
        />
        <LongTextInput
          label="Notes"
          name="notes"
          value={ props.objectData.notes }
          onChange={ props.onChange.bind(null, 'notes') }
        />
        <DropdownSelector
          label="Priority"
          name="priority"
          value={ props.objectData.priority || '' }
          options={ prioitiesOptions() }
          onChange={ props.onChange.bind(null, 'priority') }
        />
        <DropdownSelector
          label="Category"
          name="category"
          value={ props.objectData.category || '' }
          options={ categoriesOptions() }
          onChange={ props.onChange.bind(null, 'category') }
        />
        <TextInput
          label="Code"
          name="code"
          value={ props.objectData.code }
          onChange={ props.onChange.bind(null, 'code') }
        />
        <DropdownSelector
          label={
            <span>
              Group
              &nbsp;<button type="button" className="btn btn-xs btn-primary" onClick={ props.toggleModalCreateGroup.bind(null, true) }>New</button>
            </span>
          }
          name="group"
          value={ props.objectData.group.value[1] || '' }
          options={ groupsOptions(props.groups) }
          onChange={ props.onChangeRelation.bind(null, 'group') }
        />
        {
          props.showModalGroup
            ? <ModalCreateGroup onClose={ props.toggleModalCreateGroup.bind(null, false) } onGroupCreated={ props.onGroupCreated } />
            : null
        }
        <DropdownSelector
          label={
            <span>
              Owner
              &nbsp;<button type="button" className="btn btn-xs btn-primary" onClick={ props.toggleModalCreateOwner.bind(null, true) }>New</button>
            </span>
          }
          name="owner"
          value={ props.objectData.owner.value[1] || '' }
          options={ ownersOptions(props.owners) }
          onChange={ props.onChangeRelation.bind(null, 'owner') }
        />
        {
          props.showModalOwner
            ? <ModalCreateOwner onClose={ props.toggleModalCreateOwner.bind(null, false) } onOwnerCreated={ props.onOwnerCreated } />
            : null
        }
        {
          !props.objectData.source_channel_id.value[1] && parseInt(props.objectData.multi_unit) !== 1
            ? <CheckBox
                label="Get availability from ICAL"
                name="get_availability_from_ical"
                checked={ props.objectData.get_availability_from_ical }
                onChange={ props.onClickCheckbox.bind(null, 'get_availability_from_ical') }
              />
            : null
          }
          <DropdownSelector
            placehlder="---Select---"
            label="Multi-unit mode *"
            name="multi_unit"
            value={ parseInt(props.objectData.multi_unit) }
            options={ unitTypeOptions() }
            onChange={ props.onChange.bind(null, 'multi_unit') }
          />
          {
            parseInt(props.objectData.multi_unit) === 1
              ? <NumberInput
                  label="Nb units"
                  name="nb_units"
                  value={ props.objectData.nb_units }
                  onChange={ props.onChange.bind(null, 'nb_units') }
                />
              : null
          }
          <UnitsFieldset
            show={ parseInt(props.objectData.multi_unit) === 2 || (parseInt(props.objectData.multi_unit) === 0 && props.objectData.get_availability_from_ical) }
            units={ units }
            showIcal={ props.objectData.get_availability_from_ical && !props.objectData.source_channel_id.value[1] }
            onChange={ handleChangeUnits.bind(null, props) }
            noCreate={ parseInt(props.objectData.multi_unit) !== 2 }
          />
      </fieldset>
    </div>
  );
};

function prioitiesOptions() {
  return ['very_high', 'high', 'normal', 'low', 'very_low'].map(p => {
    return { name: p.replace('_', ' '), value: p };
  });
}
function categoriesOptions() {
  return ['cheap', 'standard', 'comfort', 'superior', 'luxury'].map(c => {
    return { name: c, value: c };
  });
}
function groupsOptions(groups) {
  if (!groups) return [];
  return groups.map(group => {
    return { name: group.name, value: group.id };
  });
}
function ownersOptions(owners) {
  if (!owners) return [];
  return owners.map(owner => {
    return { name: owner.name, value: owner.id };
  });
}
function unitTypeOptions() {
  return [
    { name: 'single unit', value: 0 },
    { name: 'multiple units', value: 1 },
    { name: 'independent units', value: 2 },
  ];
}

function handleChangeUnits(props, units) {
  props.onChange('units', { value: units });
}

ManagementTab.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  disabledFields: React.PropTypes.array,
  receivePropertyDetails: React.PropTypes.bool,
  onChange: React.PropTypes.func,
  onClickCheckbox: React.PropTypes.func,
  groups: React.PropTypes.array,
  toggleModalCreateGroup: React.PropTypes.func,
  showModalGroup: React.PropTypes.bool,
  onGroupCreated: React.PropTypes.func,
  owners: React.PropTypes.array,
  toggleModalCreateOwner: React.PropTypes.func,
  showModalOwner: React.PropTypes.bool,
  onOwnerCreated: React.PropTypes.func,
};

export default ManagementTab;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/components/ManagementTab.jsx